export const LEGACY_CUSTOMER_REDIRECTS = [
  { path: 'dashboard', to: '/overview' },
  { path: 'orders/new', to: '/shipping' },
  { path: 'support', to: '/contact' },
  { path: 'settings/api-tokens', to: '/api-tokens' },
  { path: 'settings/notifications', to: '/profile' },
  { path: 'wallet/transactions/:transactionId/receipt', to: '/wallet' },
] as const;

export const CUSTOMER_FRONTEND_PATHS = new Set([
  '/overview',
  '/shipping',
  '/contact',
  '/track',
  '/api-tokens',
  '/profile',
  '/wallet',
]);
